import React, { useState, useEffect, useMemo } from 'react'
import Flickity from "react-flickity-component";
import "flickity/css/flickity.css";
import { getGalleryImage } from './../api/routes';

export default function Gallery() {
  const [galleryImages, setGalleryImages] = useState([]);

  useEffect(() => {
    getGalleryImage((isOk, data) => {
      if (!isOk) return alert(data.message);
      setGalleryImages(data || []);
    })
  }, []);

  const options = useMemo(() => ({
    prevNextButtons: true,
    pageDots: false,
    groupCells: 1,
    rightToLeft: true,
    initialIndex: 0,
    contain: true,
    adaptiveHeight: false,
    setGallerySize: true,
  }), []);

  return (
    <div className="relative bg-white overflow-hidden pt-10 md:pt-24 pb-10" id="gallery">
   
      {/* Flickity theme scoped */}
      <style>{`
        .gallery-carousel .flickity-prev-next-button{
          top: 50% !important;
          transform: translateY(-50%) !important;
          width: 48px !important;
          height: 48px !important;
          border-radius: 999px !important;
          z-index: 50 !important;
          background: rgba(255,255,255,0.92) !important;
          border: 1px solid rgba(255,255,255,0.65) !important;
          box-shadow: 0 12px 34px rgba(2,132,199,0.18) !important;
          backdrop-filter: blur(10px);
        }
        .gallery-carousel .flickity-button-icon{
          fill: rgba(15,23,42,0.6) !important;
        }
        .gallery-carousel .flickity-page-dots{ display:none !important; }

        /* height lock to avoid extra bottom space */
        .gallery-carousel .flickity-viewport{
          overflow: hidden !important;
          height: 360px !important;
        }
        @media (min-width: 640px){
          .gallery-carousel .flickity-viewport{ height: 720px !important; }
        }

        .gallery-carousel .flickity-slider{
          display:flex !important;
          align-items: stretch !important;
        }
        .gallery-carousel .carousel-cell{
          padding-inline: 10px;
          height: 100%;
          display:flex;
        }
      `}</style>

      <div className="container mx-auto px-4">
        {/* heading */}
        <section className="flex flex-col items-center">
          <span className="px-5 py-2 rounded-full text-xs font-extrabold bg-[#0ea5b7] text-white shadow-md">
            گالری
          </span>

          <h2 className="mt-5 text-center text-2xl sm:text-3xl font-black text-slate-900 tracking-tight">
            گالری تصاویر مرکز
          </h2>

          <div className="mt-4 h-[3px] w-16 rounded-full bg-gradient-to-r from-[#06b6d4] via-[#22c55e] to-[#3b82f6]" />

          <p className="text-center text-sm sm:text-base mt-6 text-slate-600 max-w-2xl leading-7">
            بخشی از محیط مرکز، تجهیزات و نمونه تصاویر برای آشنایی بیشتر.
          </p>
        </section>

        {/* carousel */}
        <div className="gallery-carousel relative mt-10">
          {/* padding for arrows (prevents arrows overlay) */}
          <div className="sm:px-14">
            <Flickity className="w-full" options={options}>
              {galleryImages.map((g) => (
                <div key={g.departmentGalleryId} className="carousel-cell">
                  <div className="relative w-full h-full rounded-[28px] sm:rounded-[36px] overflow-hidden bg-white/70 backdrop-blur-xl
                                  border border-white/60 shadow-[0_22px_90px_rgba(2,132,199,0.14)] ring-1 ring-black/5">
                    <img
                      src={`data:image/jpeg;base64,${g.image}`}
                      alt=""
                      loading="lazy"
                      className="w-full h-full object-cover transition duration-700 hover:scale-[1.02]"
                    />

                    {/* top strip */}
                    <div className="absolute inset-x-0 top-0 h-2 bg-gradient-to-r from-[#06b6d4] via-[#22c55e] to-[#3b82f6]" />

                    {/* subtle vignette */}
                    <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-slate-900/15 via-transparent to-transparent" />
                  </div>
                </div>
              ))}
            </Flickity>
          </div>
        </div>

        {/* empty */}
        {galleryImages.length === 0 && (
          <div className="mt-12 text-center text-slate-600">
            فعلاً تصویری در گالری ثبت نشده است.
          </div>
        )}
      </div>
    </div>
  )
}
